import React from "react";

import { Cloudinary } from "@cloudinary/url-gen";
import { crop } from "@cloudinary/url-gen/actions/resize";
import { AdvancedVideo, placeholder } from "@cloudinary/react";

import "./HomepageDemoVideo.css";
import { CenteringView } from "../../Components/RecurringSmallViews/RecurringSmallViews";

function _DemoVideo(): JSX.Element {
  const myCld = new Cloudinary({ cloud: { cloudName: "dfno6k3qf" } });

  const cloudinaryVideo = myCld
    .video("static assets/tawkit_demo")
    .resize(crop().width(590).height(1280));

  return (
    <div className="HomepageDemoVideo_VideoContainer">
      <AdvancedVideo
        cldVid={cloudinaryVideo}
        playsInline
        poster="https://res.cloudinary.com/dfno6k3qf/video/upload/c_crop,h_1280,w_590/v1654504674/static%20assets/tawkit_demo.jpg"
        controls
        plugins={[placeholder()]}
      />
    </div>
  );
}
export function DemoVideo(): JSX.Element {
  return CenteringView(_DemoVideo());
}
